import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = 'oldPages/e-insert-management/index.html';

const links: Record<string, string> = {
  upload: '/infoTrac/e-insert-management/upload',
  edit: '/infoTrac/e-insert-management/edit',
};

function EInsertManagement() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const upload = iframeDocument.getElementById('uploadNew');
      const edit = iframeDocument.getElementsByClassName('editInsert');

      if (edit.length) {
        for (let i = 0; i < edit.length; i++) {
          edit[i].addEventListener('click', () => navigate(links.edit));
        }
      }

      if (upload) upload.addEventListener('click', () => navigate(links.upload));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="e-insert-management"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="700px"
    />
  );
}

export default EInsertManagement;
